type PartyType = 'Individual' | 'Company / Organisation';

interface PartyTypeSelectorProps {
    value: PartyType;
    onChange: (v: PartyType) => void;
    label: string;
    description: string;
}

export default function PartyTypeSelector({ value, onChange, label, description }: PartyTypeSelectorProps) {
    return (
        <div>
            <h3 className="text-[15px] font-bold text-secondary">{label}</h3>
            <p className="mt-1 text-[13px] text-[#555] font-normal">
                Choose <span className="font-semibold text-primary">Individual</span>{' '}
                {description.split('Individual')[1]?.split('Company')[0]}
                <span className="font-semibold text-primary">Company</span> {description.split('Company')[1]}
            </p>
            <div className="mt-3 grid grid-cols-2 gap-4 font-normal">
                {(['Individual', 'Company / Organisation'] as const).map((type) => (
                    <button
                        key={type}
                        type="button"
                        role="radio"
                        aria-checked={value === type ? 'true' : 'false'}
                        onClick={() => onChange(type)}
                        className={`flex w-full cursor-pointer items-center gap-3 rounded-lg border bg-transparent px-4 py-3 text-left text-[14px] transition-colors ${
                            value === type ? 'border-primary' : 'border-[#eee] hover:border-primary/20'
                        }`}
                    >
                        <span
                            aria-hidden="true"
                            className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-all ${
                                value === type ? 'border-primary' : 'border-[#ccc]'
                            }`}
                        >
                            <span
                                className={`h-2 w-2 rounded-full transition-all ${
                                    value === type ? 'bg-primary scale-100' : 'bg-transparent scale-0'
                                }`}
                            />
                        </span>
                        {type}
                    </button>
                ))}
            </div>
        </div>
    );
}
